enum routeTypeEnum {
  /**
   * Public routes, anyone can see it
   */
  public = 'public',
  /**
   * Routes like login, recovery password, activtae account, etc.
   */
  session = 'session',
  /**
   * Required session
   */
  default = 'default',
}

export default routeTypeEnum;
